import { isErrorEvent } from "../../parser/index.js";
import { formatTimestamp } from "../utils.js";
import { formatEventOutput } from "./event.js";
export function formatErrorEnvelope(container) {
    const processedEnvelope = container.getParsedEnvelope();
    const { envelope: [envelopeHeader, items], } = processedEnvelope;
    const formatted = [];
    for (const item of items) {
        const [{ type }, payload] = item;
        if (type === "event" && isErrorEvent(payload)) {
            formatted.push(...formatError(payload, envelopeHeader));
        }
    }
    return formatted;
}
export function processErrorEvent(event) {
    const entries = [];
    if (event.exception) {
        entries.push({
            type: "exception",
            data: event.exception,
        });
    }
    if (event.request) {
        entries.push({
            type: "request",
            data: event.request,
        });
    }
    if (event.breadcrumbs) {
        entries.push({
            type: "breadcrumbs",
            data: event.breadcrumbs,
        });
    }
    if (event.spans) {
        entries.push({
            type: "spans",
            data: event.spans,
        });
    }
    if (event.threads) {
        entries.push({
            type: "threads",
            data: event.threads,
        });
    }
    const message = typeof event.message === "string" ? event.message : (event.message?.formatted ?? "");
    return {
        message,
        id: event.event_id ?? "",
        type: "error",
        culprit: event.culprit ?? null,
        tags: Object.entries(event.tags ?? {}).map(([key, value]) => ({
            key,
            value: String(value),
        })),
        dateCreated: formatTimestamp(event.timestamp),
        title: message,
        entries,
        contexts: event.contexts,
        platform: event.platform,
    };
}
/**
 * Format an error event to markdown string
 */
export function formatError(payload, _envelopeHeader) {
    const event = payload;
    return [formatEventOutput(processErrorEvent(event))];
}
